import styled from '@emotion/styled';

export const ItemBox = styled.div`
	display: block;
	width: 60rem;
	border: 1px solid var(--border-color);
	border-radius: 0.5rem;
	margin: auto;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
`;

export const ItemContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 1rem;

	:hover,
	:focus,
	:active {
		background-color: var(--background-3);
	}
`;

export const Badge = styled.div`
	align-self: center;
	margin: 0 2rem;
	background: var(--textButtonBgColor);
	padding: 0.5rem;
	border-radius: 0.5rem;
`;

export const CompletedContainer = styled.div`
	padding-top: 4rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	.typography {
		text-align: center;
		line-height: 4rem;
		width: 80%;
	}
`;

export const DeleteLottieContainer = styled.div`
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const DeleteLottieSubtitle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
`;
